/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceItem } from './EvidenceItem';
import {
    EvidenceItemFromJSON,
    EvidenceItemFromJSONTyped,
    EvidenceItemToJSON,
    EvidenceItemToJSONTyped,
} from './EvidenceItem';

/**
 * A dispute entry in the evidence response
 * @export
 * @interface EvidenceDisputeItem
 */
export interface EvidenceDisputeItem {
    /**
     * 
     * @type {string}
     * @memberof EvidenceDisputeItem
     */
    disputeId?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceDisputeItem
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceDisputeItem
     */
    filedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceDisputeItem
     */
    filedAt?: number;
    /**
     * 
     * @type {Array<EvidenceItem>}
     * @memberof EvidenceDisputeItem
     */
    evidence?: Array<EvidenceItem>;
    /**
     * 
     * @type {string}
     * @memberof EvidenceDisputeItem
     */
    reason?: string;
}

/**
 * Check if a given object implements the EvidenceDisputeItem interface.
 */
export function instanceOfEvidenceDisputeItem(value: object): value is EvidenceDisputeItem {
    return true;
}

export function EvidenceDisputeItemFromJSON(json: any): EvidenceDisputeItem {
    return EvidenceDisputeItemFromJSONTyped(json, false);
}

export function EvidenceDisputeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceDisputeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'disputeId': json['disputeId'] == null ? undefined : json['disputeId'],
        'status': json['status'] == null ? undefined : json['status'],
        'filedBy': json['filedBy'] == null ? undefined : json['filedBy'],
        'filedAt': json['filedAt'] == null ? undefined : json['filedAt'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(EvidenceItemFromJSON)),
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function EvidenceDisputeItemToJSON(json: any): EvidenceDisputeItem {
    return EvidenceDisputeItemToJSONTyped(json, false);
}

export function EvidenceDisputeItemToJSONTyped(value?: EvidenceDisputeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disputeId': value['disputeId'],
        'status': value['status'],
        'filedBy': value['filedBy'],
        'filedAt': value['filedAt'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(EvidenceItemToJSON)),
        'reason': value['reason'],
    };
}

